import { render, staticRenderFns } from "./PreparationVisaInlineLegend.vue?vue&type=template&id=50deec3a&"
import script from "./PreparationVisaInlineLegend.vue?vue&type=script&lang=js&"
export * from "./PreparationVisaInlineLegend.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports